import { motion } from "framer-motion";
import { LucideIcon } from "lucide-react";

interface KpiCardProps {
  icon: LucideIcon;
  label: string;
  value: number;
  sub?: string;
  color: string;
}

interface KpiGridProps {
  kpis: KpiCardProps[];
}

export default function KpiGrid({ kpis }: KpiGridProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-8"
    >
      {kpis.map((kpi, i) => (
        <div key={i} className="bg-card rounded-2xl p-5 border border-border">
          <div className={`w-10 h-10 rounded-xl ${kpi.color} flex items-center justify-center mb-3`}>
            <kpi.icon className="w-5 h-5" />
          </div>
          <p className="text-3xl font-bold text-foreground">{kpi.value}</p>
          <p className="text-sm text-muted-foreground">{kpi.label}</p>
          {kpi.sub && <p className="text-xs text-muted-foreground mt-1">{kpi.sub}</p>}
        </div>
      ))}
    </motion.div>
  );
}
